import { ScheduleSettings } from "@/components/settings/schedule-settings-wrapper";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/schedule")({
  component: ScheduleSettings,
});
